import { Link } from "react-router-dom";
import type { RecommendItem } from "@/types/film";

export default function RecommendCard({ item }: { item: RecommendItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-100">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} 相关影视推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-accent-700">
          <i className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center text-accent-500"></i>
          {item.rating}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">{item.title}</h3>
        <p className="mt-1 text-xs text-foreground-500">{item.year} · {item.genre}</p>
        <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
      </div>
    </Link>
  );
}